<template>
    <select
        v-model="value"
        :id="id"
        class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    >
        <option v-if="!withoutEmptyOption" value="">
            {{ $t('messages.select') }}
        </option>
        <option value="1">{{ $t('messages.yes') }}</option>
        <option value="0">{{ $t('messages.no') }}</option>
        <option v-if="missing" value="NULL">
            {{ $t('messages.missing') }}
        </option>
    </select>
</template>

<script>
export default {
    name: 'IndeterminateCheckboxSelect',
};
</script>
<script setup>
import { useVModel } from '@vueuse/core';

let emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {},
    id: {},
    missing: {},
    withoutEmptyOption: {},
});

const value = useVModel(props, 'modelValue', emit);
</script>
